import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = ['💪 Vas a dejar de decir "mañana empiezo" y vas a tomar acción hoy mismo', '⚡ Vas a tener energía de sobra desde que te levantás hasta que te acostás', '🧠 Vas a silenciar el caos mental y ganar un enfoque absoluto en tus metas', '🔥 Vas a construir un físico del que te sientas orgulloso/a frente al espejo', '🛡️ Vas a desarrollar una disciplina inquebrantable que no depende de tu motivación', '✨ Vas a recuperar la confianza en vos mismo/a y en tu capacidad de lograr cosas', '⏱️ Vas a dominar tu tiempo en lugar de sentir que el día se te escapa de las manos', '🚀 Vas a crear hábitos automáticos que te impulsen hacia arriba sin esfuerzo'];
export function BenefitsSection() {
  return <section className="py-20 md:py-28 px-4 bg-beige" data-id="element-24">
      <div className="max-w-6xl mx-auto" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-26">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-4" data-id="element-27">
            Esto es lo que vas a sentir cuando empieces:
          </h2>
          <div className="w-24 h-1 bg-cta mx-auto rounded-full" data-id="element-28"></div>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-29">
          {benefits.map((benefit, index) => {
          const [icon, ...textParts] = benefit.split(' ');
          const text = textParts.join(' ');
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white p-6 rounded-2xl shadow-soft border border-border hover:border-highlight transition-colors group flex flex-col" data-id="element-30">
                <div className="bg-warm w-12 h-12 rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 text-2xl" data-id="element-31">
                  {icon}
                </div>
                <p className="text-primary font-medium leading-snug" data-id="element-32">{text}</p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}